import { applyMiddleware, createStore } from "redux";
import thunk from "redux-thunk";

import rootReducer from "admin/store/slices";
import httpMiddleware from 'admin/store/middlewares/http-middleware';

export default function configureStore(initialState) {
    return createStore(
        rootReducer,
        initialState,
        applyMiddleware(thunk, httpMiddleware)
    );
}